export default __webpack_public_path__ + "static/photo-29-0687eca0bf6149ee77615205fd94aa2a.jpg";